var _style, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMin5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 63",
    style: {
      enableBackground: "new 0 0 35 63"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000068676443612684785860000015451039409425679802_);}\r\n\t.st2{fill:url(#SVGID_00000137131993605839899210000005453546527562965146_);}\r\n\t.st3{fill:url(#SVGID_00000088835999590781804820000012848039057982308241_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.2402,
    y1: 1.9592,
    x2: 34.7598,
    y2: 1.9592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC53D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9982,
    style: {
      stopColor: "#EC7C47"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 0.5,
    className: "st0",
    width: 34.5,
    height: 3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039827899638865355480000012764915122620236706_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.2402,
    y1: 33.0044,
    x2: 34.7598,
    y2: 33.0044
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC53D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9982,
    style: {
      stopColor: "#EC7C47"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039827899638865355480000012764915122620236706_)"
    },
    d: "M30.9,43.8c0-5.1-2.8-9.5-7-11.8 c4.2-2.3,7-6.7,7-11.8V3.5h-3.4v16.7c0,5.5-4.5,10-10,10c-5.5,0-10-4.5-10-10V3.5H4v16.6c0,5.1,2.8,9.5,7,11.8 c-4.2,2.3-7,6.7-7,11.8v15.7H0.2v3h34.5v-3h-3.9V43.8z M7.4,43.8c0-5.5,4.5-10,10-10c5.5,0,10,4.5,10,10v15.7h-20V43.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155841135325539924600000009148365536740202140_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.1816,
    y1: 19.4421,
    x2: 25.9922,
    y2: 19.4421
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC53D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9982,
    style: {
      stopColor: "#EC7C47"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 9.2,
    y: 17.7,
    style: {
      fill: "url(#SVGID_00000155841135325539924600000009148365536740202140_)"
    },
    width: 16.8,
    height: 3.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135687742953301324490000005752203193933628825_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.1816,
    y1: 56.364,
    x2: 26.292,
    y2: 56.364
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC53D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9982,
    style: {
      stopColor: "#EC7C47"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 9.2,
    y: 54.7,
    style: {
      fill: "url(#SVGID_00000135687742953301324490000005752203193933628825_)"
    },
    width: 17.1,
    height: 3.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMin5);
export default __webpack_public_path__ + "static/media/icon_min5.80e773bb76f5ab51854db573e588dc2d.svg";
export { ForwardRef as ReactComponent };